import { Component, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import * as XLSX from 'xlsx';

@Component({
    selector: 'excel-to-dx-data-grid',
    templateUrl: './excel-to-dx-data-grid.html',
    styleUrls: ['./excel-to-dx-data-grid.less'],
    standalone: false
})
export class ExcelToDxDataGrid implements OnInit {
	@Output() saveData = new EventEmitter<any>();
	@ViewChild('exceltodxgrid') exceltodxgrid!: DxDataGridComponent;
	constructor(){}
	ngOnInit(): void {}
	excelPopupVisible: boolean = false;
	arrayBuffer:any;
	bstr:any;
	excelData:any = [];
	excelData2:any = [];
	excel_to_json: any;
	columnDataFields:any = [];
	finalSavedData:any = [];
	onValueChanged = (e: any) => {
		this.excelPopupVisible = true;
		const file = e.value[0];
		const fileReader = new FileReader();
		fileReader.onload = () => {
			this.arrayBuffer = fileReader.result;
			const workbook = XLSX.read(this.arrayBuffer);
			const first_sheet_name = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[first_sheet_name];
			this.excel_to_json = XLSX.utils.sheet_to_json(worksheet);
			this.columnDataFields = [];
			this.excelData = [];
			this.converToJSON();
		}
		fileReader.readAsArrayBuffer(file);
	}
	converToJSON = () => {
		Object.keys(this.excel_to_json[0]).forEach((keyName)=>{
			let tempDataFieldName = keyName.replace(/[^A-Z0-9]/ig, "");
			let isEdtiable = (["Est. Final Cost", "Variance Cmt"].includes(keyName)) ? true : false;
			let dataType = (["Account", "Variance Cmt"].includes(keyName)) ? "string" : "number" ;
			let validationRules = (["Est. Final Cost"].includes(keyName)) ? [{
				type: 'required',
				message: "Est. Final Cost is required."
			}, {
				type: 'numeric',
				message: "Only numbers are allowed."
			}, ] : [];
			let tempFormat = (["Budget Amt", "Est. Final Cost"].includes(keyName)) ? 'currency' : ((["VarianceAmt"].includes(keyName)) ? 'string' : '') ;
			this.columnDataFields.push({
				dataField: tempDataFieldName,
				caption: keyName,
				allowEditing: isEdtiable,
				dataType: dataType,
				validationRules: validationRules,
				format: tempFormat
			});
		});
		this.excel_to_json.forEach((obj:any) => {
			let tempObject:any = {};
			Object.keys(obj).forEach((keyName, index)=>{ 
				let tempDataFieldName2 = keyName.replace(/[^A-Z0-9]/ig, "");
				tempObject[tempDataFieldName2] = obj[keyName];
			});
			this.excelData.push(tempObject);
			
		});
		this.exceltodxgrid.instance.option('columns', this.columnDataFields);
		// this.exceltodxgrid.instance.option('dataSource', this.excelData);
		for (let record of this.excelData.reverse()) {
			this.exceltodxgrid.instance.on("initNewRow", (event: any)=>{
				record.__KEY__ = event.data.__KEY__;
				event.data = Object.assign(event.data, record);
			}).addRow();
		}
	}
	save = (e: any) => {
		this.exceltodxgrid.instance.saveEditData().then((resp:any)=>{
			this.finalSavedData = this.exceltodxgrid.instance.option('dataSource');
			let temp = [];
			for (let record of this.finalSavedData.reverse()) {
				//record.VarianceAmt = (record.VarianceAmt < 10000 && record.VarianceAmt != 0) ? '('+record.VarianceAmt.toString()+')' : record.VarianceAmt.toString();
				temp.push(record);
			}
			this.saveData.emit(temp);
			this.excelPopupVisible = false;
		});
	}
	onHiding = (e: any) => {
		this.exceltodxgrid.instance.cancelEditData();
		this.excelData2 = [];
	}
}
